// Generated from the English keys in lib/i18n.ts (same {slot} placeholders); reviewed 2026-09-11.
export const ES: Record<string, string> = {
  "Guess the Goal": "Guess the Goal",
  "Name the iconic goal — real rewards, server-scored": "Nombra el gol icónico — recompensas reales, puntuación del servidor",
  "Solved {n}/{total}": "Resuelto {n}/{total}",
  "+{points} points": "+{points} puntos",
  "Move {n}/{total}": "Movimiento {n}/{total}",
  "Which goal is this?": "¿Qué gol es este?",
  "Bonus question": "Pregunta extra",
  "Next goal": "Siguiente gol",
  "Guess the Goal is warming up — check back soon": "Guess the Goal se está calentando — vuelve pronto",
  "A legendary goal replays on the coaching board. The earlier you name it, the more you earn — first solve of each goal pays coins and XP.": "Un gol legendario se repite en el tablero. Cuanto antes lo nombres, más ganas — la primera solución de cada gol paga monedas y XP.",
  "(daily cap)": "(límite diario)",
  "Name the legendary goal from the coaching board": "Adivina el gol legendario en la pizarra táctica",
  "A legendary goal replays on the coaching board. Watch the moves and name the goal. Sign in to earn coins and XP.": "Un gol legendario se repite en la pizarra táctica. Mira las jugadas y adivina el gol. Inicia sesión para ganar monedas y XP.",
  "Sign in to earn coins and XP for every goal you solve": "Inicia sesión para ganar monedas y XP por cada gol que aciertes",
  "Already solved before — no repeat rewards": "Ya resuelto antes — sin recompensas repetidas",
  "Something went wrong — try again": "Algo salió mal — inténtalo de nuevo",
  "Watch the real goal": "Ver el gol real",
  "Back to the board": "Volver al tablero",
  "Board": "Tablero",
  "Video": "Vídeo",
  "Replay board": "Tablero de repetición",
  "Couldn't load your game": "No se pudo cargar tu partida",
  "Prototype — virtual points only, no real money or rewards": "Prototipo — solo puntos virtuales, sin dinero ni recompensas reales",
  "Points": "Puntos",
  "Play again": "Jugar de nuevo",
  "Try again": "Intentar de nuevo",
  "Next": "Siguiente",
  "Back": "Atrás",
  "Opponent": "Oponente",
  "Accumulator": "Acumulador",
  "Five legs. One stake. All must land.": "Cinco selecciones. Una apuesta. Todas deben acertar.",
  "Pick 5 legs · {n}/5": "Elige 5 selecciones · {n}/5",
  "Continue · {odds}x": "Continuar · {odds}x",
  "Potential return": "Ganancia potencial",
  "Your stake": "Tu apuesta",
  "Place bet · {stake}": "Realizar apuesta · {stake}",
  "Back to legs": "Volver a selecciones",
  "Return so far": "Ganancia hasta ahora",
  "4 of 5 landed!": "¡4 de 5 acertadas!",
  "Take the money or go for it?": "¿Cobrar o arriesgar?",
  "One leg left. Cash out now, or risk it for the full {amount}.": "Última selección. Cobra ahora o arriésgate por los {amount} completos.",
  "Cash out": "Cobrar",
  "Final leg": "Última selección",
  "Bet won!": "¡Apuesta ganada!",
  "Busted on leg {n}": "Fallaste en la pierna {n}",
  "Lost your {stake} stake — one leg let it down.": "Perdiste tu apuesta de {stake} — una pierna te falló.",
  "New accumulator": "Nuevo acumulador",
  "if it lands:": "si aciertas:",
  "{leg}/{total} legs": "{leg}/{total} piernas",
  "Leg {n}": "Pierna {n}",
  "Answer right to boost your odds": "Responde bien para mejorar tus cuotas",
  "Bet Slip · Treble": "Boleto de apuesta · Tripleta",
  "3 selections": "3 selecciones",
  "boosted": "mejorado",
  "Total odds": "Cuota total",
  "Boost leg {n} · {club}": "Mejorar pierna {n} · {club}",
  "Boosted {a} → {b}": "Mejorado {a} → {b}",
  "Stake {stake} · potential return": "Apuesta {stake} · retorno potencial",
  "Slip landed!": "¡Boleto acertado!",
  "Not this time": "Esta vez no",
  "The boosted {odds}x didn't come in.": "El {odds}x mejorado no llegó.",
  "New slip": "Nuevo boleto",
  "Bank it or climb — one wrong answer wipes it all": "Guárdalo o sigue subiendo — una respuesta incorrecta lo anula todo",
  "Stake": "Apuesta",
  "Wiped": "Perdido",
  "Banked": "Guardado",
  "Pot at risk": "Pot en riesgo",
  "{mult}x on {stake}": "{mult}x con {stake}",
  "Stake {stake} & climb": "Apuesta {stake} y sube",
  "Bank {pot} now, or risk it for {next}?": "¿Guardar {pot} ahora o arriesgarlo por {next}?",
  "Bank {pot}": "Guardar {pot}",
  "Climb to {mult}x": "Subir a {mult}x",
  "Wiped!": "¡Perdido!",
  "Wrong answer at {mult}x — the whole pot is gone.": "Respuesta incorrecta a {mult}x — se pierde todo el pot.",
  "Banked {amount}": "Guardado {amount}",
  "😱 It would have hit 32x!": "😱 ¡Habría llegado a 32x!",
  "Smart! You'd have busted at {mult}x.": "¡Inteligente! Habrías reventado a {mult}x.",
  "It would've climbed to {a}x then busted at {b}x.": "Habría subido a {a}x y luego reventado a {b}x.",
  "Go again": "Jugar otra vez",
  "One hard question. Winner takes the pot.": "Una pregunta difícil. El ganador se lleva el pot.",
  "Today's pot": "Pot de hoy",
  "climbing with every miss…": "subiendo con cada fallo…",
  "failed today": "fallado hoy",
  "next question": "siguiente pregunta",
  "Hard · one attempt": "Difícil · un intento",
  "Rolled over": "Acumulado",
  "Not this time — your entry fed the pot. It now sits at {pot}. Come back for the next question in {time}.": "Esta vez no — tu apuesta alimentó el bote. Ahora está en {pot}. Vuelve para la siguiente pregunta en {time}.",
  "Replay": "Volver a jugar",
  "Jackpot won!": "¡Bote ganado!",
  "The pot resets for tomorrow's question.": "El bote se reinicia para la pregunta de mañana.",
  "Live": "En vivo",
  "Half-Time Quiz": "Quiz del descanso",
  "Question {n} / {total}": "Pregunta {n} / {total}",
  "Get {n}+ for a free bet · {c} right": "Consigue {n}+ para una apuesta gratis · {c} aciertos",
  "Free bet won!": "¡Apuesta gratis ganada!",
  "{c}/{total} — so close": "{c}/{total} — muy cerca",
  "You earned a virtual second-half free bet (demo — no real rewards).": "Ganaste una apuesta gratis virtual para la segunda parte (demo — sin recompensas reales).",
  "Get {n}+ right before kickoff to earn a free bet.": "Consigue {n}+ aciertos antes del inicio para ganar una apuesta gratis.",
  "Markets": "Mercados",
  "Odds are illustrative · prototype": "Cuotas ilustrativas · prototipo",
  "Prototype — virtual only": "Prototipo — solo virtual",
  "Odds Board": "Marcador de cuotas",
  "Every answer is a market — back your call": "Cada respuesta es un mercado — apuesta por tu elección",
  "Market {n}": "Mercado {n}",
  "{pct}% implied": "{pct}% implícito",
  "returns": "retornos",
  "Pick an answer to back": "Elige una respuesta para apostar",
  "Place {stake} on {answer}": "Haz una apuesta de {stake} a {answer}",
  "Won {amount}!": "¡Ganaste {amount}!",
  "Lost {amount}": "Perdiste {amount}",
  "Big-odds call!": "¡Llamada de cuota alta!",
  "Right answer:": "Respuesta correcta:",
  "Next market": "Siguiente mercado",
  "Pass Chain": "Pass Chain",
  "Link the two players through shared clubs": "Conecta a los dos jugadores a través de clubes compartidos",
  "Fewer links score higher": "Menos conexiones, mayor puntuación",
  "Par —": "Par —",
  "Par {par} links": "Par {par} conexiones",
  "Who links to {name}?": "¿Quién se conecta con {name}?",
  "Add": "Añadir",
  "Already in the chain": "Ya en la cadena",
  "Unknown player — try another": "Jugador desconocido — prueba otro",
  "{a} never played with {b}": "{a} nunca jugó con {b}",
  "Reset": "Reiniciar",
  "Linked!": "¡Vinculado!",
  "{n} links": "{n} vínculos",
  "Par — perfect!": "¡Par — perfecto!",
  "par {n}": "par {n}",
  "Next chain": "Siguiente cadena",
  "START": "INICIAR",
  "TARGET": "OBJETIVO",
  "Penalty Shootout": "Tanda de penaltis",
  "Round {n} / {total}": "Ronda {n} / {total}",
  "You · AI": "Tú · IA",
  "Answer to earn your shot": "Responde para ganar tu tiro",
  "Opponent is stepping up…": "El oponente se prepara…",
  "AI is on target — get ready to dive!": "La IA apunta — prepárate para lanzarte",
  "AI answering…": "La IA responde…",
  "Pick your corner — beat the keeper": "Elige tu palo — supera al portero",
  "You're in goal — pick your dive!": "Estás en la portería — ¡elige tu lance!",
  "GOAL!": "¡GOL!",
  "MISSED": "FALLADO",
  "AI SCORES": "LA IA MARCA",
  "SAVED!": "¡GUARDADO!",
  "Opponent's turn": "Turno del oponente",
  "See result": "Ver resultado",
  "Next round": "Siguiente ronda",
  "You win!": "¡Tú ganas!",
  "Draw": "Empate",
  "You lose": "Tú pierdes",
  "Free Kicks": "Tiros Libres",
  "Know football. Read the goal. Take the shot.": "Conoce de fútbol. Lee la portería. Lanza a gol.",
  "Balance": "Saldo",
  "Pot": "Bote",
  "Your pot": "Tu bote",
  "Stake {n} & attack": "Apuesta {n} y ataca",
  "Min {n}": "Mín. {n}",
  "Top up (demo)": "Recargar (demo)",
  "Answer to scout the keeper": "Responde para tantear al portero",
  "{n}s": "{n}s",
  "Time's up — blind shot": "Se acabó el tiempo — tiro a ciegas",
  "Wrong — the correct answer stays. Blind shot.": "Incorrecto — la respuesta correcta se queda. Tiro a ciegas.",
  "Answer to scout the keeper — knowledge sharpens the shot, the risk stays.": "Responde para tantear al portero — el conocimiento agudiza el tiro, el riesgo se queda.",
  "Attack {n}": "Atacar {n}",
  "SCOUT REPORT ✓ — one save zone revealed": "INFORME DE OJEADOR ✓ — zona de parada revelada",
  "No scout — blind shot pays more": "Sin ojeador — tiro a ciegas paga más",
  "Pick your shot zone": "Elige tu zona de tiro",
  "4 GOAL · 2 SAVE": "4 GOLES · 2 PARADAS",
  "4 GOAL · 1 SAVE": "4 GOLES · 1 PARADA",
  "TAKE {amount}": "COBRAR {amount}",
  "NEXT ATTACK": "SIGUIENTE ATAQUE",
  "Next attack risks the whole pot — the keeper resets.": "El siguiente ataque arriesga todo el bote — el portero se reinicia.",
  "The keeper read it — pot lost.": "El portero lo leyó — bote perdido.",
  "Cashed out {amount}!": "¡Cobraste {amount}!",
  "Loading…": "Cargando…",
  "Could not load balance — tap to retry": "No se pudo cargar el saldo — toca para reintentar",
  "New round": "Nueva ronda",
  "Live wins": "Victorias en vivo",
  "Longest runs today": "Mejores rachas hoy",
  "{n} playing now": "{n} jugando ahora",
  "{pct}% answered correctly": "{pct}% respondieron correctamente",
  "{pct}% scored": "{pct}% marcaron",
  "{pct}% cashed out": "{pct}% cobraron",
  "{n} going NEXT ATTACK": "{n} en el PRÓXIMO ATAQUE",
  "You": "Tú",
  "just now": "hace nada",
  "{n}m ago": "hace {n}m",
  "Squad Collection": "Colección de Plantilla",
  "Answer to pull cards. Build your XI.": "Responde para sacar cartas. Forma tu XI.",
  "Squad": "Plantilla",
  "Answer to earn a pack": "Responde para ganar un sobre",
  "Tap to open": "Toca para abrir",
  "Add to squad": "Añadir a la plantilla",
  "Squad complete!": "¡Plantilla completa!",
  "Reward: +2,000 🪙": "Recompensa: +2.000 🪙",
  "Start a new squad": "Crear nueva plantilla",
  "Bronze": "Bronce",
  "Silver": "Plata",
  "Gold": "Oro",
  "Special": "Especial",
  "Easy": "Fácil",
  "Hard": "Difícil",
  "Expert": "Experto",
  "Name a player who fits every reel": "Nombra un jugador que encaje en todos los carretes",
  "{n} reels": "{n} carretes",
  "Spin": "Girar",
  "Spinning…": "Girando…",
  "Name a player…": "Nombra un jugador…",
  "Go": "Ir",
  "Hold a reel, respin the rest": "Mantén un carrete, gira los demás",
  "Respin −{n}": "Girar de nuevo -{n}",
  "Last 3 spins": "Últimos 3 giros",
  "Missed": "Fallado",
  "Correct!": "¡Correcto!",
  "Only {pct}% named this": "Solo el {pct}% lo nombró",
  "rarity": "rareza",
  "Time's up": "Tiempo agotado",
  "You could've said:": "Podrías haber dicho:",
  "No valid player for that combo!": "¡No hay jugador válido para esa combinación!",
  "Spin again": "Gira de nuevo",
  "Hold reel": "Mantener carrete",
  "Release reel": "Soltar carrete",
  "Club": "Club",
  "Position": "Posición",
  "Nation": "Nación",
  "Era": "Época",
  "Trophy": "Trofeo",
  "easy": "fácil",
  "medium": "medio",
  "hard": "difícil",
  "Answer to earn spins — the wheel pays out": "Responde para ganar giros — la ruleta paga",
  "Coins": "Monedas",
  "Question {n}": "Pregunta {n}",
  "+1 spin earned": "+1 giro ganado",
  "No spin — try the next one": "Sin giro — prueba el siguiente",
  "{n} spins available": "{n} giros disponibles",
  "JACKPOT!": "¡PREMIO MAYOR!",
  "Spin the wheel": "Gira la ruleta",
  "Answer to earn a spin": "Responde para ganar un giro",
  "Full Time Result": "Resultado Final",
  "Next Goal": "Próximo Gol",
  "Total Goals Over/Under 3.5": "Goles Totales Más/Menos de 3.5",
  "Both Teams to Score — 2nd Half": "Ambos Equipos Marcan — 2ª Parte",
  "No more goals": "No hay más goles",
  "Over 3.5": "Más de 3.5",
  "Under 3.5": "Menos de 3.5",
  "Yes": "Sí",
  "No": "No",
  "Champions League · Group Stage": "Champions League · Fase de grupos",
  "Real Madrid to win": "Gana el Real Madrid",
  "Man City to win": "Gana el Man City",
  "Bayern to win": "Gana el Bayern",
  "Goalkeeper": "Portero",
  "Zone": "Zona",
  "Defender": "Defensa",
  "Midfielder": "Centrocampista",
  "Forward": "Delantero",
  "World Cup": "Mundial",
  "League": "Liga",
  "Champions League": "Champions League",
  "League Title": "Título de Liga",
  "Football Tic Tac Toe": "Fútbol Tres en Raya",
  "Claim cells with players — three in a row wins": "Ocupa casillas con jugadores; tres en raya gana",
  "You · Opponent": "Tú · Rival",
  "Pick a cell and name a player who played for that club AND that nation. Your opponent answers back — line up three to win.": "Elige una casilla y di el nombre de un jugador que jugara en ese club Y esa selección. Tu oponente responde — alinea tres para ganar.",
  "Start match": "Empezar partido",
  "Your turn — pick a cell": "Tu turno — elige una casilla",
  "Not a match — turn passes": "No es un acierto — pasa el turno",
  "Time's up — turn passes": "Se acabó el tiempo — pasa el turno",
  "Pass": "Pasar",
  "Opponent blanked — your turn!": "El oponente no ha acertado — ¡tu turno!",
  "Opponent is thinking…": "El oponente está pensando…",
  "Opponent wins": "El oponente gana",
  "Three in a row!": "¡Tres en raya!",
  "Board full — {a} cells vs {b}": "Tablero lleno — {a} casillas vs {b}",
  "New grid": "Tablero nuevo",
  "{pct}%": "{pct}%",
  "Brazil": "Brasil",
  "France": "Francia",
  "Argentina": "Argentina",
  "Spain": "España",
  "Netherlands": "Países Bajos",
  "Portugal": "Portugal",
  "Survivor": "Superviviente",
  "One wrong answer and you are out — how long can you last?": "Una respuesta incorrecta y estás fuera. ¿Cuánto durarás?",
  "Streak": "Racha",
  "Sudden death": "Muerte súbita",
  "Questions get harder as you go. {n} virtual players start with you — outlast them all.": "Las preguntas se vuelven más difíciles. Empiezas con {n} jugadores virtuales. Supéralos a todos.",
  "Best streak: {n}": "Mejor racha: {n}",
  "Enter the arena": "Entra en la arena",
  "Still standing": "Aún en pie",
  "Eliminated": "Eliminado",
  "Streak of {n}": "Racha de {n}",
  "You outlasted {pct}% of the field — {left} were still standing.": "Superaste al {pct}% de los jugadores. Quedaron {left} en pie.",
  "New best!": "¡Nuevo récord!",
  "Run it back": "Vuelve a intentarlo",
  "Last one standing!": "¡El último en pie!",
  "You cleared every question in the bank — a perfect {n}-answer run.": "Superaste todas las preguntas del banco. Una racha perfecta de {n} respuestas.",
  "Hi-Lo Ride": "Viaje Alto-Bajo",
  "Call the higher stat — odds priced by how many get it right": "Adivina la estadística más alta. Cuotas basadas en cuántos aciertan.",
  "Chain higher-or-lower calls. Every correct call multiplies your stake — hard matchups pay more. Cash out before you miss.": "Encadena pronósticos alto-bajo. Cada acierto multiplica tu apuesta. Los partidos difíciles pagan más. Retira tu dinero antes de fallar.",
  "Stake {stake} & ride": "Apuesta {stake} y juega",
  "Step {n} · odds": "Ronda {n} · cuota",
  "{pct}% of players call this one right": "El {pct}% de los jugadores acierta esta",
  "Which is higher?": "¿Cuál es mayor?",
  "Higher": "Mayor",
  "Pot is {pot}. Next matchup pays {odds}x → {next}.": "Bote: {pot}. Próximo partido paga {odds}x → {next}.",
  "Cash out {pot}": "Cobrar {pot}",
  "Ride on": "Seguir",
  "Wrong call": "Decisión incorrecta",
  "The ride ends — your {stake} stake is gone.": "La partida termina — tu apuesta de {stake} se ha perdido.",
  "New ride": "Nueva partida",
  "Cashed {amount}!": "¡Cobraste {amount}!",
  "{n} correct calls — {mult}x your stake.": "{n} aciertos — {mult}x tu apuesta.",
  "Trivia Mines": "Trivia Mines",
  "Dribble past hidden defenders — scout them with your knowledge": "Esquiva defensas ocultos — descúbrelos con tu conocimiento",
  "{d} defenders hide in {n} tiles. Every clean dribble grows the pot — hit a defender and lose it all. Answer questions to scout defenders out.": "{d} defensas se esconden en {n} casillas. Cada regate limpio aumenta el bote — toca un defensa y piérdelo todo. Responde preguntas para descubrir defensas.",
  "Stake {stake} & dribble": "Apuesta {stake} y regatea",
  "Tackled": "Derribado",
  "Now · next tile": "Ahora · siguiente casilla",
  "Scout ({n} left)": "Descubrir ({n} restantes)",
  "{n} safe tiles opened · {d} defenders in play": "{n} casillas seguras abiertas · {d} defensas en juego",
  "Scout report — a defender is marked!": "Informe de exploración — ¡un defensa está marcado!",
  "Scout failed — no intel": "Fallo de exploración — sin información",
  "Answer to scout a defender": "Responde para otear un defensa",
  "Tackled!": "¡Entrada!",
  "A defender got you after {n} clean tiles — the pot is gone.": "Un defensa te atrapó tras {n} casillas limpias — el bote se ha ido.",
  "New run": "Nueva partida",
  "{n} clean dribbles at {mult}x.": "{n} regates limpios a {mult}x.",
  "Quiz Board": "Tablero Quiz",
  "Pick tiles, bank the value — steal when the AI slips": "Elige casillas, acumula el valor — roba cuando la IA falle",
  "Nine tiles, three value tiers. Answer to bank the tile and keep control — miss and the AI can steal. Highest bank wins.": "Nueve casillas, tres niveles de valor. Responde para asegurar la casilla y mantener el control — falla y la IA puede robar. Gana quien más acumule.",
  "Start game": "Empezar partida",
  "Clubs": "Clubes",
  "Legends": "Leyendas",
  "Tournaments": "Torneos",
  "Your board — pick a tile": "Tu tablero — elige una casilla",
  "AI is picking a tile…": "La IA está eligiendo una casilla…",
  "AI plays for {v}": "La IA juega por {v}",
  "AI banks it": "La IA lo acumula",
  "AI is wrong — steal it!": "La IA se equivoca — ¡roba!",
  "STEAL for {v}!": "¡ROBA por {v}!",
  "For {v}": "Por {v}",
  "Final banks — you {a}, AI {b}.": "Acumulaciones finales — tú {a}, IA {b}.",
  "New board": "Nuevo tablero",
  "Last One Standing": "El último en pie",
  "{n} enter, one survives — make every cut": "{n} entran, uno sobrevive — haz cada corte",
  "Alive": "Vivo",
  "Battle royale quiz": "Quiz de batalla real",
  "Every round the field is cut — answer right and fast to stay in it. Nine rounds from {n} players down to one.": "Cada ronda el campo se reduce — responde bien y rápido para seguir. Nueve rondas de {n} jugadores a uno.",
  "Kick off": "Comienzo",
  "Continue": "Continuar",
  "A legendary goal replays on the coaching board. Name it — the first solve of each goal pays coins and XP.": "Un gol legendario se repite en el tablero táctico. Nómbralo — la primera solución de cada gol paga monedas y XP.",
  "A legendary goal replays on the coaching board. Watch the moves and name the goal.": "Un gol legendario se repite en el tablero táctico. Mira los movimientos y nombra el gol.",
  "Back tomorrow": "Vuelve mañana",
  "All {limit} goals played — come back tomorrow": "Todos los {limit} goles jugados — vuelve mañana",
  "{left} of {limit} goals left today": "Quedan {left} de {limit} goles hoy",
  "Daily coins earned — more tomorrow": "Monedas diarias ganadas — más mañana",
  "Today: {today}/{cap} coins": "Hoy: {today}/{cap} monedas",
  "Your collection": "Tu colección",
  "Fastest {cap} survive": "Los {cap} más rápidos sobreviven",
  "Field": "Campo",
  "You made the cut!": "¡Pasaste el corte!",
  "#{rank} fastest — {cap} players remain.": "#{rank} más rápido — quedan {cap} jugadores.",
  "Cut!": "¡Corte!",
  "Finished #{place} of {n}": "Terminaste #{place} de {n}",
  "Round {r} was your last — the field marched on without you.": "La ronda {r} fue tu última; el campo siguió sin ti.",
  "Re-enter": "Volver a entrar",
  "CHAMPION!": "¡CAMPEÓN!",
  "{n} started. You are the last one standing.": "{n} empezaron. Eres el último en pie.",
  "Defend the title": "Defiende el título",
  "Golden Goal": "Gol de Oro",
  "Sudden death — push the ball into their net": "Muerte súbita: mete el balón en su portería",
  "Round": "Ronda",
  "Both of you answer the same question — faster and righter pushes the ball. Reach ±{n} and it is a goal. First goal wins.": "Ambos respondéis la misma pregunta: el más rápido y certero avanza. Llega a ±{n} y es gol. El primero en marcar gana.",
  "AI net": "Portería IA",
  "Your attack": "Tu ataque",
  "GOLDEN GOAL!": "¡GOL DE ORO!",
  "AI scores": "La IA marca",
  "Decided in {n} rounds.": "Decidido en {n} rondas.",
  "Rematch": "Revancha",
  "vs": "vs",
  "Career Race": "Carrera Profesional",
  "The transfer trail reveals — buzz before your rival": "Se revela el rastro de fichajes: ¡toca antes que tu rival!",
  "Clubs appear one by one. Buzz early for 100 points — every extra club cuts the prize. Wrong buzz and you are out of the round. Best of {n}.": "Los clubes aparecen uno a uno. Toca antes para 100 puntos; cada club extra reduce el premio. Si tocas mal, quedas fuera de la ronda. Lo mejor de {n}.",
  "Start race": "Empezar carrera",
  "Buzz now: {pts} pts": "Toca ahora: {pts} pts",
  "Locked out": "Bloqueado",
  "BUZZ!": "¡TOCA!",
  "Rival buzzed wrong — they are out!": "¡Tu rival tocó mal y quedó fuera!",
  "Your rival is watching the same trail…": "Tu rival está viendo el mismo camino…",
  "Whose career is this?": "¿De quién es esta carrera?",
  "Wrong — locked out!": "¡Mal — bloqueado!",
  "⚡ Rival buzzes…": "⚡ El rival toca…",
  "+{pts} — yours!": "+{pts} — ¡tuyos!",
  "Rival takes {pts}": "El rival se lleva {pts}",
  "Nobody got it": "Nadie lo adivinó",
  "It was {name}": "Era {name}",
  "You win the race!": "¡Ganas la carrera!",
  "Rival wins": "El rival gana",
  "Race again": "Volver a correr",
  "Closest Wins": "Aproximado futbolero",
  "No options, no help — land your guess on the number": "Sin opciones, sin ayuda: acierta el número",
  "Score": "Puntuación",
  "{n} numeric stats — slide to your best guess. The closer you land, the more you score; a perfect hit pays a bullseye bonus.": "Estadísticas numéricas de {n}: desliza para adivinar lo mejor posible. Cuanto más te acerques, más puntos obtendrás; un acierto perfecto te da un bonus de diana.",
  "Take aim": "Apunta",
  "Target {n} / {total}": "Objetivo {n} / {total}",
  "Lock it in": "Confirma",
  "Answer": "Respuesta",
  "BULLSEYE! +{pts}": "¡DIANA! +{pts}",
  "+{pts} pts": "+{pts} pts",
  "You were {diff} off.": "Te equivocaste por {diff}.",
  "Next target": "Siguiente objetivo",
  "Elite sniper!": "¡Francotirador de élite!",
  "Sharp shooter": "Tirador certero",
  "On the range": "En el campo de tiro",
  "Blindfolded": "Con los ojos vendados",
  "{score} points over {n} targets": "{score} puntos en {n} objetivos",
  "Reload": "Recargar",
  "Every shot is a 50/50 duel with the keeper. Answer questions to boost the payout — a wrong answer resets the boost.": "Cada tiro es un duelo 50/50 contra el portero. Responde preguntas para aumentar el pago: una respuesta incorrecta reinicia el bonus.",
  "Boost {a}/{max} · ×{mult}": "Bonus {a}/{max} · ×{mult}",
  "BOOSTED! Payout is now ×{mult}": "¡BONUS! El pago es ahora ×{mult}",
  "Wrong — boost resets to ×{mult}": "Incorrecto: el bonus se reinicia a ×{mult}",
  "50/50 shot · current payout ×{mult}": "Tiro 50/50 · pago actual ×{mult}",
  "Answer · boost to ×{next}": "Respuesta · mejora a ×{next}",
  "Boosts raise the payout — the shot stays 50/50.": "Las mejoras aumentan el pago — el tiro sigue siendo 50/50.",
  "Boosting…": "Mejorando…",
  "Time's up — boost resets to ×{mult}": "Se acabó el tiempo — la mejora se reinicia a ×{mult}",
  "Left or right — the keeper picks one": "Izquierda o derecha — el portero elige una",
  "Pick your corner": "Elige tu esquina",
  "Next attack risks the whole pot — the boost resets.": "El siguiente ataque arriesga todo el bote — la mejora se reinicia.",
  "Run ×{run} → ×{next}": "Carrera ×{run} → ×{next}",
  "Run": "Carrera",
  "Answering is locked this attack — take the shot.": "Responder está bloqueado este ataque — tira a puerta.",
  "Sound settings": "Ajustes de sonido",
  "Crowd": "Multitud",
  "Effects": "Efectos",
  "Off": "Desactivado",
  "More open zones = better odds of keeping the run alive.": "Más zonas abiertas = más posibilidades de mantener la racha.",
  "The goal opens with 2 zones and one hidden keeper. Answer questions to open up to 6 — a wrong answer slams it back to 2.": "La portería se abre con 2 zonas y un portero oculto. Responde preguntas para abrir hasta 6 — una respuesta incorrecta la cierra de nuevo a 2.",
  "{k} open · {pct}% · ×{mult}": "{k} abiertas · {pct}% · ×{mult}",
  "Zone opened! {k} of {max} in play": "¡Zona abierta! {k} de {max} en juego",
  "Pick your angle and shoot · {pot} → {next}": "Elige tu ángulo y dispara · {pot} → {next}",
  "Wrong — goal slams back to {n} zones": "Incorrecto — la portería se cierra a {n} zonas",
  "{k} zones open · 1 keeper hidden · {pct}% goal": "{k} zonas abiertas · 1 portero oculto · {pct}% gol",
  "Answer · open zone {n}": "Responder · zona abierta {n}",
  "Shoot · {pot} → {next}": "Disparar · {pot} → {next}",
  "More zones = safer shot, smaller payout — the maths favours knowing.": "Más zonas = disparo más seguro, menos recompensa — las matemáticas favorecen el conocimiento.",
  "Opening the goal…": "Abriendo la portería…",
  "Read the question…": "Lee la pregunta…",
  "Time's up — the goal slams back to {n} zones": "Se acabó el tiempo — la portería se cierra a {n} zonas",
  "Wrong — the goal slams back to {n} zones": "Incorrecto — la portería se cierra a {n} zonas",
  "{k} zones open — one hides the keeper": "{k} zonas abiertas — una oculta al portero",
  "{pct}% goal": "{pct}% gol",
  "Next attack risks the whole pot — the goal resets to {n} zones.": "El siguiente ataque arriesga todo el bote — la portería se reinicia a {n} zonas.",
  "Guess the Card": "Adivina la Carta",
  "FIFA Cards": "Cartas FIFA",
  "Spin for a FIFA edition, then name the player from the stats": "Gira para una edición FIFA, luego nombra al jugador por sus estadísticas",
  "Spinning the edition…": "Girando la edición…",
  "Locked in!": "¡Bloqueado!",
  "Guess the player from the drawn edition": "Adivina el jugador de la edición sorteada",
  "Card": "Carta",
  "No clues": "Sin pistas",
  "{clue} unlocks in": "{clue} se desbloquea en",
  "Final clue — answer now": "Última pista — responde ahora",
  "Name the player…": "Nombra al jugador…",
  "Named on stats alone": "Nombrado solo por estadísticas",
  "Guessed with {n} clue(s)": "Adivinado con {n} pista(s)",
  "Round complete": "Ronda completa",
  "of {max} · {n}/{total} named": "de {max} · {n}/{total} nombrados",
  "Card {n}/{total}": "Carta {n}/{total}",
  "Spin for a FIFA edition, then name the player from the card": "Gira para una edición FIFA, luego nombra al jugador de la carta",
  "Give up": "Rendirse",
  "Wrong!": "¡Incorrecto!",
  "Medium": "Medio",
  "Very hard": "Muy difícil",
  "Medium/Easy": "Medio/Fácil",
  "Pre-FIFA 20": "Pre-FIFA 20",
  "Tap a lock to reveal a clue": "Toca un candado para revelar una pista",
  "Clue revealed": "Pista revelada",
  "The answer": "La respuesta",
  "{clue} unlocks next": "{clue} desbloquea lo siguiente",
  "Nice — +{p}": "Bien — +{p}",
  "Daily complete!": "¡Completado diario!",
  "Today's round is done": "La ronda de hoy ha terminado",
  "Coins earned": "Monedas ganadas",
  "Solved": "Resuelto",
  "New cards at reset": "Nuevas cartas al reiniciar",
  "Come back tomorrow": "Vuelve mañana",
  "Reveal clue": "Revelar pista",
  "Hidden clue": "Pista oculta",
  "Back to challenges": "Volver a desafíos",
  "A gold card, stats only — name the player across 10 editions.": "Una carta de oro, solo estadísticas — nombra al jugador en 10 ediciones.",
  "Tap a lock to buy that clue": "Toca un candado para comprar esa pista",
  "Today {n} pts": "Hoy {n} pts",
  "Correct now = {n} pts": "Correcto ahora = {n} pts",
  "Not {name} · −{n} coins": "No es {name} · −{n} monedas",
  "Revealed": "Revelado",
  "Reveal {clue} for {n} coins": "Revelar {clue} por {n} monedas",
  "Hint budget": "Presupuesto de pistas",
  "Hint budget: {n} pts": "Presupuesto de pistas: {n} pts",
  "Hint budget resets every card · separate from your coins": "El presupuesto se reinicia en cada carta · no son tus monedas",
  "Not {name} · −{n} pts": "No es {name} · −{n} pts",
  "Reveal {clue} for {n} pts": "Revelar {clue} por {n} pts",
  "Buy clues on the card, name the player, keep your points": "Compra pistas en la carta, nombra al jugador y conserva tus puntos",
  "Hints bought: {n}": "Pistas compradas: {n}",
  "No hints bought": "Sin pistas compradas",
  "+{n} pts saved by skipping hints": "+{n} pts ahorrados sin pistas",
  "No points on a surrendered card": "Una carta abandonada no suma puntos",
  "Next card": "Siguiente carta",
  "See results": "Ver resultados",
  "{n} pts": "{n} pts",
  "Points saved through deduction": "Puntos ahorrados por deducción",
  "Across {n} solved cards": "En {n} cartas resueltas",
  "photo": "foto",
  "nation": "nación",
  "position": "posición",
  "club": "club",
  "league": "liga",
  "POS": "POS",
  "NATION": "PAÍS",
  "LEAGUE": "LIGA",
  "CLUB": "CLUB",
  "Dealing…": "Cargando…",
  "Your card": "Tu carta",
  "Buy clues on the card, name the player, keep your coins": "Compra pistas en la carta, nombra al jugador, conserva tus monedas",
  "Start": "Empezar",
  "Run complete": "Partida completa",
  "Rival": "Rival",
};
